// extracted by mini-css-extract-plugin
export var editInput = "_g1-0";
export var editInputCompact = "_g1-2";
export var editInputLarge = "_g1-1";
export var editInputSmall = "_g1-3";